import Vue from "vue";

Vue.component("statistics-summary-bar-chart", {
    props: ["header", "id"],
    data() {
        return {
            statisticsAnnexValueData: {
                labels: [],
                datasets: []
            },
            modalVisible: false,
            numberOfNotificationsPerYearPerTypes: [],
            statisticsSummaryChartData: []
        }
    },
    mounted() {
        this.loadData();
    },    
    methods: {
        loadData() {
            const self = this;

            self.statisticsAnnexValueData.labels = [];
            self.statisticsAnnexValueData.datasets = [];

            self.$services.statistics.getStatisticsSummary({
                notificationId: self.id
            }).then((data) => {
                if (data != null) {
                    if (data.annexNumbers != null && data.annexNumbers.length > 0) {
                        data.annexNumbers.forEach(annexNumber => {
                            self.statisticsAnnexValueData.labels.push(annexNumber);
                        })
                    }

                    //self.numberOfNotificationsPerYearPerTypes = [];
                    //self.numberOfNotificationsPerYearPerTypeFormats = [];

                    //let tempNumberOfNotificationsPerYearPerTypes = [];

                    if (data.annexValues != null && data.annexValues.length > 0) {

                        //const specificNumberOfNotificationsPerYearPerTypes = data.yearlyCounts.filter(item => {
                        //    return item.specific;
                        //});

                        //const nonSpecificNumberOfNotificationsPerYearPerTypes = data.yearlyCounts.filter(item => {
                        //    return !item.specific;
                        //});

                        //if ((specificNumberOfNotificationsPerYearPerTypes != null
                        //    && specificNumberOfNotificationsPerYearPerTypes.length > 0) ||
                        //    (nonSpecificNumberOfNotificationsPerYearPerTypes != null &&
                        //        nonSpecificNumberOfNotificationsPerYearPerTypes.length > 0)) {


                        //    if (specificNumberOfNotificationsPerYearPerTypes != null
                        //        && specificNumberOfNotificationsPerYearPerTypes.length > 0) {

                        //        data.annexValues.forEach(annexValue => {
                        //            self.numberOfNotificationsPerYearPerTypeFormats.push({
                        //                id: item.notificationFormatId,
                        //                name: item.notificationFormatName,
                        //                backgroundColor: item.backgroundColor
                        //            });
                        //        });

                        //    }

                        //    if (nonSpecificNumberOfNotificationsPerYearPerTypes != null
                        //        && nonSpecificNumberOfNotificationsPerYearPerTypes.length > 0) {

                        //        nonSpecificNumberOfNotificationsPerYearPerTypes.forEach(item => {
                        //            if (item.notificationCounts != null
                        //                && item.notificationCounts.length > 0
                        //                && item.notificationCounts[0].details != null
                        //                && item.notificationCounts[0].details.length > 0) {
                        //                item.notificationCounts[0].details.forEach(detailItem => {
                        //                    self.numberOfNotificationsPerYearPerTypeFormats.push({
                        //                        id: detailItem.notificationFormatId,
                        //                        name: detailItem.notificationFormatName,
                        //                        backgroundColor: item.backgroundColor
                        //                    });
                        //                });
                        //            }
                        //        });
                        //    }

                        //    for (let index = self.distributionYearFrom; index <= self.distributionYearTo; index++) {

                        //        let tempNumberOfNotificationsPerYearPerType = {};

                        //        tempNumberOfNotificationsPerYearPerType['year'] = index;
                        //        tempNumberOfNotificationsPerYearPerType['count'] = 0;
                        //        tempNumberOfNotificationsPerYearPerType['hasData'] = false;

                        //        self.numberOfNotificationsPerYearPerTypeFormats.forEach(typeItem => {
                        //            tempNumberOfNotificationsPerYearPerType['column' + typeItem.id] = 0;
                        //        });

                        //        tempNumberOfNotificationsPerYearPerTypes.push(tempNumberOfNotificationsPerYearPerType);
                        //    }

                        //    if (specificNumberOfNotificationsPerYearPerTypes != null
                        //        && specificNumberOfNotificationsPerYearPerTypes.length > 0) {

                        //        specificNumberOfNotificationsPerYearPerTypes.forEach(item => {
                        //            if (item.notificationCounts != null && item.notificationCounts.length > 0) {
                        //                item.notificationCounts.forEach(countItem => {
                        //                    const tempSpecificNumberOfNotificationsPerYearPerTypeItem = tempNumberOfNotificationsPerYearPerTypes.filter(tempItem => {
                        //                        return tempItem.year == countItem.year;
                        //                    });

                        //                    if (tempSpecificNumberOfNotificationsPerYearPerTypeItem[0] != null) {
                        //                        tempSpecificNumberOfNotificationsPerYearPerTypeItem[0].hasData = true;
                        //                        tempSpecificNumberOfNotificationsPerYearPerTypeItem[0].count = tempSpecificNumberOfNotificationsPerYearPerTypeItem[0].count + countItem.count;
                        //                        tempSpecificNumberOfNotificationsPerYearPerTypeItem[0]['column' + item.notificationFormatId] = countItem.count;
                        //                    }
                        //                });
                        //            }
                        //        });
                        //    }

                        //    if (nonSpecificNumberOfNotificationsPerYearPerTypes != null
                        //        && nonSpecificNumberOfNotificationsPerYearPerTypes.length > 0) {

                        //        nonSpecificNumberOfNotificationsPerYearPerTypes.forEach(item => {
                        //            if (item.notificationCounts != null && item.notificationCounts.length > 0) {
                        //                item.notificationCounts.forEach(countItem => {
                        //                    const tempNonSpecificNumberOfNotificationsPerYearPerTypeItem = tempNumberOfNotificationsPerYearPerTypes.filter(tempItem => {
                        //                        return tempItem.year == countItem.year;
                        //                    });

                        //                    if (tempNonSpecificNumberOfNotificationsPerYearPerTypeItem[0] != null) {
                        //                        tempNonSpecificNumberOfNotificationsPerYearPerTypeItem[0].hasData = true;
                        //                        tempNonSpecificNumberOfNotificationsPerYearPerTypeItem[0].count = tempNonSpecificNumberOfNotificationsPerYearPerTypeItem[0].count + countItem.count;

                        //                        countItem.details.forEach(detailItem => {
                        //                            tempNonSpecificNumberOfNotificationsPerYearPerTypeItem[0]['column' + detailItem.notificationFormatId] = detailItem.count;
                        //                        });
                        //                    }
                        //                });
                        //            }
                        //        });
                        //    }

                        //    self.numberOfNotificationsPerYearPerTypes = tempNumberOfNotificationsPerYearPerTypes.filter(item => {
                        //        return item.hasData;
                        //    });
                        //}

                        data.annexValues.forEach(annexValue => {
                            let annexValueData = [];
                            if (annexValue.values != null && annexValue.values.length > 0) {
                                annexValue.values.forEach(value => {
                                    annexValueData.push(value.value);
                                });
                            }

                            const dataset = {
                                label: annexValue.currencyName,
                                data: annexValueData
                            };
                            self.statisticsAnnexValueData.datasets.push(dataset);
                        });
                    }
                }
            })
        },
        showModal() {
            this.modalVisible = true;
        },
        closeModal() {
            this.modalVisible = false;
        }
    },
    template: `
        <div>
	        <section class="card">
                <header class="card-header">
                    <h1 class="card-header-title">{{header}}</h1>
                    <a @click.prevent="showModal" style="margin-right: 20px;">
                        <i class="fas fa-table primary-text fa-2x"></i>
                    </a>
                </header>
                <div class="card-content">
                    <div class="content">
                        <bar-chart :id="id" :width="400" :height="400" data-key="label" :data="statisticsAnnexValueData"></bar-chart>
                    </div>
                </div>
            </section>
            <b-modal id="statisticsSummaryBarChartModal" full-screen ref="statisticsSummaryBarChartModal" v-model="modalVisible" #default="props" :can-cancel="['x']">
                <div class="modal-card" style="overflow-y: auto;">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{header}}</p>
                        <button type="button" class="delete" @@click="closeModal" />
                    </header>
                    <section class="modal-card-body">
                        <div class="card">
                            <div class="card-content">
                                <div class="table-container">
                                    <b-table :data="numberOfNotificationsPerYearPerTypes">
                                        <b-table-column field="year" label="Year" v-slot="props" :td-attrs="((row,column) => ({ class: 'statisticsSummaryChartDataHeader'}))">
                                            {{ props.row.year }}
                                        </b-table-column>
                                        <b-table-column v-for="numberOfNotificationsPerYearPerTypeFormat in numberOfNotificationsPerYearPerTypeFormats"
                                                    :key="numberOfNotificationsPerYearPerTypeFormat.id"
                                                    :id="numberOfNotificationsPerYearPerTypeFormat.id"
                                                    :label="numberOfNotificationsPerYearPerTypeFormat.name"
                                                    :th-attrs="((column) => ({ class: 'statisticsSummaryChartDataHeader'}))"
                                                    v-slot="props">
                                            {{props.row['column' + numberOfNotificationsPerYearPerTypeFormat.id]}}
                                        </b-table-column>
                                        <b-table-column field="count" label="Total" v-slot="props" :td-attrs="((row,column) => ({ class: 'statisticsSummaryChartDataHeader'}))">
                                            {{ props.row.count }}
                                        </b-table-column>
                                    </b-table>                                    
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </b-modal>
        </div>
	`
});